import { Flex } from "@theme-ui/components";
import React from "react";
import { StatisticsBox } from "../atoms";
import Customers from "./Customers";

const styles = {
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: ["4rem", "4rem", "7rem", "7rem"],
  "@media screen and (max-width: 1150px)": {
    px: "0.5rem",
  },
};

const TestimonialSection = ({region}) => {
  return (
    <Flex sx={styles}>
      <Customers region={region} />
      <StatisticsBox />
    </Flex>
  );
};

export default React.memo(TestimonialSection);
